import { call, put, takeLatest } from "redux-saga/effects";

import { getUniversalJusfinderStatus } from "../app/helpers/universalJusfinder";

const INITIAL_STATE = {
  isUniversalJusfinder: false,
  isLoading: true,
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LOAD_UNIVERSAL_JUSFINDER_STATUS":
      return { ...state, isLoading: true };
    case "LOAD_UNIVERSAL_JUSFINDER_STATUS_SUCCESS":
      return { ...state, isUniversalJusfinder: action.payload, isLoading: false };
    case "LOAD_UNIVERSAL_JUSFINDER_STATUS_FAILED":
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

function* loadUniversalJusfinderStatus() {
  try {
    const response = yield call(getUniversalJusfinderStatus);

    if (!response.success) {
      yield put({ type: "LOAD_UNIVERSAL_JUSFINDER_STATUS_FAILED" });
      return;
    }

    yield put({
      type: "LOAD_UNIVERSAL_JUSFINDER_STATUS_SUCCESS",
      payload: response.data?.isUniversalJusfinder ?? false,
    });
  } catch (err) {
    yield put({ type: "LOAD_UNIVERSAL_JUSFINDER_STATUS_FAILED" });
  }
}

export function* saga() {
  yield takeLatest("LOAD_UNIVERSAL_JUSFINDER_STATUS", loadUniversalJusfinderStatus);
}
